<template>
  <v-card tile flat class="create-new-banner px-3" :color="$vuetify.theme.dark ? '#172233' : '#e8f1f8'">
    <v-card-title class="pt-5 pb-5 pl-0">Banners History </v-card-title>
    <v-row dense>
      <v-col cols="12" sm="12">
        <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTabTable registerUserTable"
            :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
            <v-data-table :headers="headers" :items="Transaction" :items-per-page="7">
              <!-- Email Column -->
              <template v-slot:item.learnMoreLink="{ item }">
                <v-tooltip top color="#000">
                  <template v-slot:activator="{ on }">
                    <v-btn plain title x-small class="text-lowercase" v-on="on" @click="copyText(item.learnMoreLink)">
                      {{ item.learnMoreLink }}
                      <v-icon x-small class="ml-1">mdi-content-copy</v-icon>
                    </v-btn>
                  </template>
                  <span>Click to copy</span>
                </v-tooltip>
              </template>
              <template v-slot:item.timeframeView="{ item }">
                <span :class="item.className">{{ item.timeframeView }}</span>
              </template>

              <template v-slot:item.details="{ item }">
                <div class="d-flex justify-space-around">
                  <div class="">
                    <v-dialog transition="scale-transition" origin="center center" max-width="1020" persistent
                      v-model="dialog3" content-class="deposit-withdraw-popup marketingPopup">
                      <template v-slot:activator="{ on, attrs }">
                        <span class="links" v-bind="attrs" v-on="on">
                          <v-icon color="#039de9" small>
                            {{ item.details }}
                          </v-icon>
                        </span>
                      </template>
                      <v-card class="rounded-0 px-3 pt-10" :class="$vuetify.theme.dark
                          ? 'blue-darken-1'
                          : 'white-lighten-5'
                        ">
                        <v-card tile flat class="image-wrapper pa-0"
                          :color="$vuetify.theme.dark ? '#1a2a3d' : '#e8f1f8'">
                          <v-row dense no-gutters align="center">
                            <v-col cols="12" sm="12" md="12" lg="8">
                              <v-card-subtitle>
                                Invite friends & earn together
                                <router-link class="text-capitalize d-block indigo--text accent-4" to="/">
                                  Learn Details
                                </router-link>
                              </v-card-subtitle>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" lg="4">
                              <v-img max-height="160" max-width="360" contain class="small-img"
                                src="@/assets/banner-small.png"></v-img>
                            </v-col>
                          </v-row>
                        </v-card>
                        <v-card-actions class="pl-0 mt-5">
                          <v-row dense>
                            <v-col cols="12">
                              <v-btn tile color="#FF567F" @click="dialog3 = false" elevation="0"
                                class="text-capitalize btn-account px-sm-8">Close</v-btn>
                            </v-col>
                          </v-row>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </div>
                  <div class="trade-dropdown">
                    <v-menu rounded="0" class="trade-dropdown-menu" transition="slide-x-transition" bottom left>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn small tile elevation="0" class="ma-0 text-capitalize btn-account" v-bind="attrs"
                          v-on="on" icon>
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-card class="dropdown-menu-card" tile flat>
                        <v-list flat elevation="0" :class="$vuetify.theme.dark
                            ? 'blue-darken-1'
                            : 'white-lighten-1'
                          ">
                          <v-list-item-group>
                            <v-list-item :ripple="false">
                              <v-list-item-content>
                                <v-dialog transition="scale-transition" origin="center center" max-width="600"
                                  persistent v-model="dialog2" content-class="deposit-withdraw-popup marketingPopup">
                                  <template v-slot:activator="{ on, attrs }">
                                    <span class="text-decoration-none" v-bind="attrs" v-on="on">Edit</span>
                                  </template>
                                  <v-card tile flat class="create-new-banner px-3" :color="$vuetify.theme.dark
                                      ? '#172233'
                                      : '#e8f1f8'
                                    ">
                                    <v-card-title>Edit Banners </v-card-title>
                                    <v-row dense>
                                      <v-col lg="12" md="12" sm="12" cols="12">
                                        <v-card-text class="pb-0 pl-3">
                                          <v-radio-group v-model="ex1" row class="mt-0">
                                            <v-radio label="For Partner" value="full-control" color="teal"
                                              class="custom-radio-buttons" :ripple="false"></v-radio>
                                            <v-radio label="For Client" value="read-only" color="teal"
                                              class="custom-radio-buttons" :ripple="false"></v-radio>
                                            <v-radio label="For All" value="no-access" color="teal"
                                              class="custom-radio-buttons" :ripple="false"></v-radio>
                                          </v-radio-group>
                                        </v-card-text>
                                        <div class="profileView px-3 mb-3">
                                          <v-card class="verification-card" flat tile :color="$vuetify.theme.dark
                                              ? '#1A2A3E'
                                              : '#F1F7FB'
                                            ">
                                            <v-card-actions class="px-0">
                                              <v-card-title class="pl-1 pt-5">
                                                <v-icon class="pr-2" color="#708AA7">mdi
                                                  mdi-account-outline</v-icon>Upload Banner Image
                                              </v-card-title>
                                            </v-card-actions>

                                            <v-card-subtitle class="mx-auto text-center">
                                              Upload Image in .png or .jpg file
                                              <br />
                                              Our Recommended image Size is 350
                                              * 160
                                            </v-card-subtitle>
                                            <div class="zone-wrapper justify-center">
                                              <v-card-text class="text-center">
                                                <vue-dropzone ref="myVueDropzone" id="dropzone"
                                                  :options="dropzoneOptions"></vue-dropzone>
                                                <div class="dropzone-content">
                                                  <v-icon large class="mb-3" color="#708AA7">mdi
                                                    mdi-tray-arrow-up</v-icon>
                                                  <p class="mb-0">
                                                    Drop File Here or
                                                    <strong>Browse</strong>
                                                  </p>
                                                  <span>File size max 5MB</span>
                                                </div>
                                              </v-card-text>
                                            </div>
                                          </v-card>
                                        </div>
                                        <div class="global-fieldset px-3">
                                          <fieldset class="mb-3">
                                            <legend>Banner Title</legend>
                                            <v-text-field v-model="BannerTitle" label="Write Here" single-line solo
                                              dense hide-details class="custom-select"></v-text-field>
                                          </fieldset>
                                          <fieldset class="mb-3">
                                            <legend>Learn More Link</legend>
                                            <v-text-field v-model="LearnMoreLink" label="input redirect link"
                                              single-line solo dense hide-details class="custom-select"></v-text-field>
                                          </fieldset>
                                        </div>
                                        <div class="global-fieldset px-3 mb-1">
                                          <v-row dense align="center">
                                            <v-col cols="12" sm="12" md="12" lg="6">
                                              <fieldset class="mb-3">
                                                <legend>
                                                  <i class="fa fa-lastfm-square" aria-hidden="true"></i>
                                                  Banner Show Date
                                                </legend>
                                                <v-dialog ref="dialog4" v-model="modal" :return-value.sync="date"
                                                  persistent width="290px"
                                                  class="deposit-withdraw-popup marketingPopup">
                                                  <template v-slot:activator="{ on, attrs }">
                                                    <div class="global-fieldset px-3 mb-1">
                                                      <v-text-field v-model="dateRangeText" prepend-icon="mdi-calendar"
                                                        append-icon="mdi-chevron-down" readonly v-bind="attrs" v-on="on"
                                                        solo class="custom-select mt-0 custom-select-datepicker"
                                                        hide-details dense></v-text-field>
                                                    </div>
                                                  </template>
                                                  <v-date-picker v-model="date" class="custom-date-picker" scrollable
                                                    range>
                                                    <v-spacer></v-spacer>
                                                    <v-btn :color="$vuetify.theme.dark
                                                        ? '#ff567f'
                                                        : '#ff567f'
                                                      " text @click="modal = false">
                                                      Cancel
                                                    </v-btn>
                                                    <v-btn :color="$vuetify.theme.dark
                                                        ? '#fff'
                                                        : '#131c29'
                                                      " text @click="
                                                        $refs.dialog4.save(date)
                                                        ">
                                                      OK
                                                    </v-btn>
                                                  </v-date-picker>
                                                </v-dialog>
                                              </fieldset>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" lg="6">
                                              <v-radio-group v-model="ex2" row class="mt-0">
                                                <v-radio label="Show Always" value="full-control" color="teal"
                                                  class="custom-radio-buttons mt-3 ml-1" :ripple="false"></v-radio>
                                                <v-radio label="Visibility Stop" value="read-only" color="teal"
                                                  class="custom-radio-buttons mt-3 mr-3" :ripple="false"></v-radio>
                                              </v-radio-group>
                                            </v-col>
                                          </v-row>
                                        </div>
                                        <div class="px-3 mb-6">
                                          <v-btn :ripple="false" tile elevation="0" class="custom-btn mr-3"
                                            color="#039de9" @click="dialog2 = false">
                                            Submit Banner
                                          </v-btn>
                                          <v-btn :ripple="false" tile elevation="0" class="custom-btn mr-3"
                                            color="#FF567F" @click="dialog2 = false">
                                            Close
                                          </v-btn>
                                        </div>
                                      </v-col>
                                    </v-row>
                                  </v-card>
                                </v-dialog>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item :ripple="false">
                              <v-list-item-content>
                                <a class="text-decoration-none">Delete</a>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-card>
                    </v-menu>
                  </div>
                </div>
              </template>
              <template v-slot:item.trxProof="{ item }">
                <v-dialog transition="scale-transition" origin="center center" max-width="554" v-model="dialog"
                  content-class="deposit-withdraw-popup">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-img max-height="36" max-width="79" contain class="small-img" :src="item.trxProof"></v-img>
                    </span>
                  </template>
                  <template>
                    <v-card class="rounded-0 bg-transparent pa-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                      <v-btn icon color="#172233" @click="dialog = false" style="
                          position: absolute;
                          top: 1rem;
                          right: 1rem;
                          z-index: 1;
                        ">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>

                      <v-img class="white--text align-end" :src="item.trxProof"></v-img>
                    </v-card>
                  </template>
                  <template v-slot:item.email="{ item }">
                    <v-tooltip top color="#000">
                      <template v-slot:activator="{ on }">
                        <v-btn plain title x-small v-on="on" @click="copyText">
                          {{ item.email }}
                          <v-icon x-small class="ml-1">mdi-content-copy</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ item.email }}</span>
                    </v-tooltip>
                  </template>
                </v-dialog>
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { mapState } from "vuex";

export default {
  name: "dropzoneView",
  data() {
    return {
      ex1: "full-control",
      ex2: "full-control",
      BannerTitle: "",
      LearnMoreLink: "",
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 100,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" },
      },
      modal: false,
      dialog: false,
      date: ["2022-01-01", "2023-01-01"],
      dialog: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      headers: [
        { text: "SL", value: "SlView" },
        { text: "Banner For", value: "BannerFor" },
        { text: "Proof", value: "trxProof" },
        { text: "Banner Title", value: "BannerTitle" },
        { text: "Lern More Link", value: "learnMoreLink" },
        { text: "Visible Timeframe", value: "timeframeView" },
      ],
      Transaction: [
        {
          SlView: 1,
          BannerFor: "For Partner",
          trxProof: require("@/assets/banner-small.png"),
          BannerTitle: "Invite friends & earn together",
          learnMoreLink: "www.forexcrm.com/partners",
          timeframeView: "20/12/2020 - 21/12/2021",
          className: "",
          details: "mdi-eye-outline",
        },
        {
          SlView: 2,
          BannerFor: "For Partner",
          trxProof: require("@/assets/banner-small.png"),
          BannerTitle: "Invite friends & earn together",
          learnMoreLink: "www.forexcrm.com/partners",
          timeframeView: "Show Always",
          className: "text--green",
          details: "mdi-eye-outline",
        },
        {
          SlView: 3,
          BannerFor: "For Partner",
          trxProof: require("@/assets/banner-small.png"),
          BannerTitle: "Invite friends & earn together",
          learnMoreLink: "www.forexcrm.com/partners",
          timeframeView: "Visibility Stop",
          className: "text-red",
          details: "mdi-eye-outline",
        },
      ],
    };
  },

  components: {
    vueDropzone: vue2Dropzone,
  },

  computed: {
    dateRangeText() {
      return this.date.join(" ~ ");
    },
    ...mapState("admins", ["loggedAdmin"]),
  },

  methods: {
    copyText(learnMoreLink) {
      navigator.clipboard
        .writeText(learnMoreLink)
        .then(() => {
          alert("Email copied to clipboard!"); // Add feedback to the user
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    },
    getTextColor(item) {
      return item.class;
    },
  },

  created() {
    if (this.$canRoute('banner-upload') === 1) {
      this.headers.push({ text: "Action", value: "details" });
    }
  }
};
</script>